import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAllComics } from "../utils/comicUtils";
import { handleImgError } from "../utils/thumbnailUtils";
import { PageSEO } from "../hooks/useSEO";
import "../styles/styles.css";

const ComicCard = ({ comic }) => {
  const navigate = useNavigate();
  return (
    <div className="content-card" onClick={() => navigate(`/comics/${comic.id}`)}>
      <div className="card-poster">
        <img src={comic.thumbnail} alt={comic.title} onError={(e) => handleImgError(e, comic.title, 400, 560)} />
        <div className="card-overlay">
          <div className="card-overlay-info">
            <span className="card-badge">{comic.issues} números</span>
            <span className="card-badge">{comic.genre[0]}</span>
          </div>
        </div>
      </div>
      <div className="card-info">
        <h3 className="card-title">{comic.title}</h3>
        <p className="card-meta">{comic.author}</p>
      </div>
    </div>
  );
};

const Comics = () => {
  const [allComics, setAllComics] = useState([]);
  const [filteredComics, setFilteredComics] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState("");

  useEffect(() => {
    const comics = getAllComics();
    setAllComics(comics);
    setFilteredComics(comics);
  }, []);

  useEffect(() => {
    if (!selectedGenre) {
      setFilteredComics(allComics);
    } else {
      setFilteredComics(allComics.filter((c) => c.genre.includes(selectedGenre)));
    }
  }, [selectedGenre, allComics]);

  const allGenres = [...new Set(allComics.flatMap((c) => c.genre))];
  const featured = [...allComics].sort((a, b) => b.popularity - a.popularity).slice(0, 1)[0];

  return (
    <div className="catalog-page">
      <PageSEO
        title="Cómics IA"
        description="Descubre cómics originales creados con inteligencia artificial. Superhéroes, fantasía, distopía y más — solo en AIVEO."
        url="/comics"
      />
      {/* Hero */}
      {featured && (
        <div className="catalog-hero" style={{ backgroundImage: `url(${featured.thumbnail})` }}>
          <div className="hero-overlay" />
          <div className="hero-content">
            <span className="hero-badge">🎨 Cómic Destacado</span>
            <h1 className="hero-title">{featured.title}</h1>
            <p className="hero-synopsis">{featured.synopsis.slice(0, 120)}...</p>
            <button className="btn-primary" onClick={() => window.location.href = `/comics/${featured.id}`}>
              Leer Ahora
            </button>
          </div>
        </div>
      )}

      <div className="content-wrapper">
        <div className="catalog-header">
          <h2 className="section-title">🎨 Cómics IA</h2>
          <div className="genre-tabs">
            <button
              className={`genre-tab ${!selectedGenre ? "active" : ""}`}
              onClick={() => setSelectedGenre("")}
            >
              Todos
            </button>
            {allGenres.map((g) => (
              <button
                key={g}
                className={`genre-tab ${selectedGenre === g ? "active" : ""}`}
                onClick={() => setSelectedGenre(g)}
              >
                {g}
              </button>
            ))}
          </div>
        </div>

        <div className="content-grid">
          {filteredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Comics;
